import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import Icon from '@veeva/corgix/icon';
import { css } from '@emotion/core';
import useMessageService from '../../services/i18n/useMessageService';
import getTargetAttribute from '../../services/getTargetAttribute';

const SelfRegistrationConfirmation = () => {
    const [[description = 'Please follow the registration instructions.']] = useMessageService([
        'register.self_register_email_sent_description',
    ]);

    return (
        <>
            <div
                css={({ green }) => css`
                    margin-bottom: 3.33rem;
                    color: ${green};

                    // Corgix wrote CSS targeting .svg-inline--fa so this uses data-icon to be more specific
                    svg[data-icon='check-circle'] {
                        height: 8.333rem;
                        width: 8.333rem;
                    }
                `}
            >
                <Icon type={faCheckCircle} />
            </div>
            <div
                data-target={getTargetAttribute('self-register-confirmation-description')}
                css={css`
                    text-align: center;
                `}
            >
                {description}
            </div>
        </>
    );
};

export default SelfRegistrationConfirmation;
